import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "./Context/AuthContext";
import "./GetStartedSection.css";

const GetStartedSection = () => {
  const { isLoggedIn } = useAuth();
  const navigate = useNavigate();

  const handleQuoteClick = () => {
    // if (isLoggedIn) {
    //   navigate("/quote");
    // } else {
    //   const confirmed = window.confirm(
    //     "견적서 페이지는 로그인이 필요합니다.\n\n로그인 하시겠습니까?"
    //   );
    //   if (confirmed) {
    //     navigate("/login");
    //   }
    // }
    navigate("/quote");
  };
  return (
    <section className="get-started-section-container">
      <div className="get-started-section">
        <h1>더는 고민하지 마세요.</h1>
        <h3>에이콘이 쉽고, 빠르고, 정확하게 나만의 책을 만들어 드립니다!</h3>
        <p>* 무료 상담 & 맞춤 피드백으로 출간 가능성부터 확인</p>
        <p>* 저자 주도+전문가 지원: 완전 자비 출판도, 공동 기획도 OK</p>
        <p>* 글로벌 유통까지 한 번에 연결</p>
        <div className="get-started-buttons">
          <button
            className="get-started-section-button"
            onClick={handleQuoteClick}
          >
            모의 견적 산출하기
          </button>
          <Link to="/get-started">
            <button className="get-started-section-button">
              출판 상담 신청하기
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default GetStartedSection;
